import React from "react";
import Levels from "./Levels";


const Building = (props) => {

	return (
		<div className={'levels'}>
			<div className='building'>
				<div className='building-title'>
					<h2>Building {props.data.name}</h2>
				</div>

				<Levels data={props.data.levels} status={props.status} statusChange={props.statusChange} appName={props.appName}/>
			</div>
		</div>
	);
};

export default Building;